import React from 'react';

// Style
import './Pagination.scss';

// Classes
import clsx from 'clsx';

// Components
import Img from 'components/Img';

// Interface
interface IPagination {
	total?: number | undefined,
	isWhite?: boolean | undefined,
	disabled?: boolean | undefined,
	currentPage?: number | undefined,
	onPrevPress?: () => void | undefined,
	onNextPress?: () => void | undefined,
	onNextPressLast?: () => void | undefined,
	onPrevPressLast?: () => void | undefined,
	onPagePress?: (page: number) => void | undefined,
}

export const Pagination: React.FC<IPagination> = (props) => {
	const {
		isWhite,
		disabled,
		total = 1,
		onPagePress,
		onPrevPress,
		onNextPress,
		onNextPressLast,
		onPrevPressLast,
		currentPage = 1
	} = props;

	const cnDisabled = clsx(
		'pagination flex flex-ai-center flex-jc-center',
		disabled ? 'pagination__disabled' : '',
		isWhite ? 'pagination__white' : ''
	);

	const disabledPrevBtnLast =
		currentPage !== 1 ? (disabled ? () => {
		} : onPrevPressLast) : () => {
		};
	const disabledPrevBtn =
		currentPage !== 1 ? (disabled ? () => {
		} : onPrevPress) : () => {
		};

	const disabledNextBtn =
		currentPage !== total ? (disabled ? () => {
		} : onNextPress) : () => {
		};
	const disabledNextBtnLast =
		currentPage !== total ? (disabled ? () => {
		} : onNextPressLast) : () => {
		};

	const arrow = isWhite ? 'chevronWhite' : 'chevronRight';
	const arrows = isWhite ? 'chevronsWhite' : 'chevronsRight';

	return (
		<div className={cnDisabled}>
			<>
				<button className="pagination__prev" onClick={disabledPrevBtnLast}>
					<Img name={arrows} className="pagination__prev--icon-prev" />
				</button>
				<button className="pagination__prev" onClick={disabledPrevBtn}>
					<Img name={arrow} className="pagination__prev--icon-prev" />
				</button>
			</>
			<div className="pagination__wrapper-button flex flex-ai-center">
				{currentPage > 5 && (
					<div className="flex align-items-center">
						<button
							onClick={disabled ? () => {
							} : onPagePress ? () => onPagePress(1) : () => {
							}}
							className="pagination__item-number flex flex-ai-center flex-jc-center"
						>
							1
						</button>
						<button
							onClick={disabled ? () => {
							} : onPagePress ? () => onPagePress(2) : () => {
							}}
							className="pagination__item-number flex flex-ai-center flex-jc-center"
						>
							2
						</button>
						<p className="pagination__text">...</p>
					</div>
				)}

				{total ? (
					[-2, -1, 0, 1, 2].map((item, index) => {
						const classesPagination = clsx(
							{
								'pagination__item-number--active': currentPage + item === currentPage
							},
							'pagination__item-number flex flex-ai-center flex-jc-center',
							currentPage + item > 100 ? 'pagination__item-number--size' : ''
						);
						return currentPage + item > 0 && currentPage + item <= total ? (
							<button
								key={'page' + index}
								className={classesPagination}
								onClick={
									disabled ? () => {
									} : onPagePress ? () => onPagePress(currentPage + item) : () => {
									}
								}
							>
								{currentPage + item}
							</button>
						) : null;
					})
				) : (
					<p className="pagination__item-number flex flex-ai-center flex-jc-center">1</p>
				)}
			</div>

			{currentPage < total - 4 && (
				<div className="flex flex-ai-center">
					<p className="pagination__text">...</p>
					<button
						className={`pagination__item-number flex flex-ai-center flex-jc-center ${(total - 1) > 100 ? 'pagination__item-number--size' : ''}`}
						onClick={disabled ? () => {
						} : onPagePress ? () => onPagePress(total - 1) : () => {
						}}
					>
						{total - 1}
					</button>
					<button
						className={`pagination__item-number flex flex-ai-center flex-jc-center ${total > 100 ? 'pagination__item-number--size' : ''}`}
						onClick={disabled ? () => {
						} : onPagePress ? () => onPagePress(total) : () => {
						}}
					>
						{total}
					</button>
				</div>
			)}
			<>
				<button onClick={disabledNextBtn} className="pagination__next">
					<Img name={arrow} className="pagination__next--icon-next" />
				</button>
				<button className="pagination__next" onClick={disabledNextBtnLast}>
					<Img name={arrows} className="pagination__next--icon-next" />
				</button>
			</>
		</div>
	);
};

export default Pagination;
